module.exports = __webpack_public_path__ + "img/location.10797f3b.svg";